import { useEffect, useState } from "react";
import { useDispatch, useStore } from "react-redux"; // Add these imports
import { SupportChatbot } from "../types";
import { AdaSupportChatbot, HTSAssistSupportChatbot } from "../supportChatbots";
import { SelfServeState } from "../store";

export function useSupportChatbotFactory(
  chatVariant?: string
): SupportChatbot | undefined {
  const [chatbot, setChatbot] = useState<SupportChatbot | undefined>(undefined);
  const dispatch = useDispatch();
  const store = useStore<SelfServeState>();

  useEffect(() => {
    const createAndUpdateChatbot = async () => {
      let newChatbot: SupportChatbot | undefined;

      if (chatVariant === "legacy") {
        newChatbot = new AdaSupportChatbot();
      } else if (chatVariant === "available") {
        const getState = () => store.getState();
        newChatbot = new HTSAssistSupportChatbot(dispatch, getState);
      } else {
        console.log("No chatbot configured");
      }

      setChatbot(newChatbot);
    };

    createAndUpdateChatbot();
  }, [chatVariant, dispatch, store]); // Add dispatch and store to dependencies

  return chatbot;
}
